import React from 'react';
import Hint from '../../../../commons/components/Hint';

import S from './style/ReturnsStatusInfo';

interface ReturnsStatusInfoProps {
  textKeyName: string;
  returnId: string;
  actionDeadline?: string;
  postingDeadlineStart?: string;
  postingDeadlineEnd?: string;
}

const ReturnsStatusInfo: React.FC<ReturnsStatusInfoProps> = ({
  textKeyName,
  returnId,
  actionDeadline,
  postingDeadlineStart,
  postingDeadlineEnd,
}) => (
  <S.StatusInfo data-cy="returns-status-info">
    <Hint
      hintKey={textKeyName}
      returnId={returnId}
      actionDeadline={actionDeadline}
      postingDeadlineStart={postingDeadlineStart}
      postingDeadlineEnd={postingDeadlineEnd}
    />
  </S.StatusInfo>
);

export default ReturnsStatusInfo;
